<template>
  <div class="quick-search box">
    <figure class="image is-128x128">
      <img src="/static/logos/logo-no-text.png" alt="taskflex.dk" />
    </figure>

    <h1 class="title is-spaced is-uppercase">
      Få løst dine opgaver af en studerende
    </h1>

    <p class="subtitle is-size-6">
      Vælg din opgavetype og kontakt en dygtig studerende på kun 30 sekunder!
    </p>

    <div class="skill-groups" v-if="!skillGroup">
      <div v-if="skillGroups.length" class="tags">
        <span
          class="tag is-hoverable is-light is-medium"
          v-for="(group, index) in skillGroups"
          @click="selectGroup(group)"
          :key="index"
        >
          {{ $t('skills.groups.' + group.name + '.name') }}
        </span>
      </div>

      <div v-else class="has-text-centered">
        <b-icon icon="loading" custom-class="mdi-spin" size="is-small" />
        Indlæser...
      </div>
    </div>

    <div class="skills" v-else-if="!skill">
      <h2 class="subtitle">
        {{ $t('skills.groups.' + skillGroup.name + '.name') }}
      </h2>

      <div class="tags">
        <span
          class="tag is-hoverable is-white is-medium"
          @click="selectGroup(null)"
        >
          {{ $t('global.actions.back') }}
        </span>

        <span
          v-for="(skill, index) in skillGroup.skills"
          class="tag is-hoverable is-light is-medium"
          @click="selectSkill(skill)"
          :key="index"
        >
          {{ $t('skills.' + skill.name + '.name') }}
        </span>
      </div>
    </div>

    <div class="students" v-else>
      <h2 class="subtitle">
        {{ $t('skills.groups.' + skillGroup.name + '.name') }}:
        {{ $t('skills.' + skill.name + '.name') }}
      </h2>

      <div class="has-text-left">
        <span @click="selectSkill()" class="button is-primary is-outlined">{{
          $t('global.actions.back')
        }}</span>
      </div>

      <template v-if="students.length">
        <div class="columns is-multiline">
          <div
            v-for="(student, index) in students"
            :key="student.id"
            class="column"
            :class="classForStudentCard(index)"
          >
            <student :student="student" :displaySkill="skill" />
          </div>
        </div>

        <div class="box is-radiusless">
          <h2 class="subtitle">Mangler du den rigtige?</h2>

          <p>
            Husk du kan kontakte os, så kan vi se om vi kan finde en studerende
            der passer til lige netop din opgave.
            <br />
            Det gør du på <a href="mailto:info@taskflex.dk">info@taskflex.dk</a>
          </p>
        </div>
      </template>

      <loader v-else text="Indlæser.." style="min-height: 150px" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../global/styles/_variables';

.image {
  margin: 20px auto 15px;
}

.students {
  .subtitle {
    margin-bottom: 0.75rem;
  }
}

.tags {
  justify-content: center;

  .tag {
    user-select: none;

    &:hover {
      cursor: pointer;
      background-color: $primary;
      color: #ffffff;
    }
  }
}
</style>

<script>
import Loader from '@/global/components/Loader'
import SkillGroupService from '@/taskflex/skills/services/SkillGroupService'
import StudentService from '@/taskflex/students/services/StudentService'
import Student from '@/taskflex/students/components/search/Student'

export default {
  data () {
    return {
      skillGroups: [],
      skillGroup: null,
      skill: null,
      students: []
    }
  },

  limit: 3,

  mounted () {
    this.loadSkillGroups()
  },

  watch: {
    skill () {
      if (!this.skill) {
        this.students = []
        return
      }

      this.loadStudents()
    }
  },

  methods: {
    selectSkill (skill) {
      this.skill = skill
    },

    selectGroup (group) {
      this.skillGroup = group
    },

    loadStudents () {
      const options = {
        includes: ['level', 'skills', 'skills.paygrades'],

        limit: this.$options.limit,

        filter_groups: [
          {
            filters: [
              {
                key: 'activated',
                operator: 'eq',
                value: true
              },
              {
                key: 'hasSkill',
                operator: 'eq',
                value: this.skill.id
              }
            ]
          }
        ]
      }

      StudentService.findAll(options, ({ data: { rows } }) => {
        this.students = rows
      })
    },

    loadSkillGroups () {
      const options = {
        includes: ['skills'],

        filter_groups: [
          {
            filters: [
              {
                key: 'hasSkillsWithStudents',
                operator: 'eq',
                value: 1
              }
            ]
          }
        ]
      }

      SkillGroupService.findAll(options, ({ data: { rows } }) => {
        this.skillGroups = rows
      })
    },

    classForStudentCard (index) {
      // card count -> card index
      const classMatrix = {
        1: {
          0: ['is-half-tablet', 'is-offset-one-quarter-tablet']
        },

        2: {
          0: ['is-half-tablet'],

          1: ['is-half-tablet']
        },

        3: {
          0: ['is-half-desktop', 'is-one-third-widescreen'],

          1: ['is-half-desktop', 'is-one-third-widescreen'],

          2: [
            'is-hidden-tablet-only',
            'is-hidden-desktop-only',
            'is-one-third-widescreen'
          ]
        }
      }

      return classMatrix[this.students.length][index]
    }
  },

  components: {
    Loader,
    Student
  }
}
</script>



// WEBPACK FOOTER //
// src/infrastructure/home/components/QuickSearch.vue